<template>
  <div :class="$style.header">
    <div :class="$style.left">
      <div :class="$style.image">
        <img v-if="department?.logo" :src="department?.logo" alt="" />
      </div>
      <div :class="$style.title">{{ department?.title }}</div>
    </div>
    <div :class="$style.right">
      <div :class="$style.date">{{ date }}</div>
      <div :class="$style.time">{{ time }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Header",
  props: {
    date: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      department: (state) => state.department.department,
    }),
  },
};
</script>

<style lang="scss" module>
.header {
  padding: 1rem;
  background-color: $bg-primary;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-weight: 600;
  .date,
  .title,
  .time {
    font-size: 2.25rem;
  }
  .left {
    display: flex;
    align-items: center;
    gap: 1rem;
    .image {
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    gap: 2.5rem;
  }
}
</style>
